/**
 * Created by neo on 29.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { TimeRange, createTimeRangeFields } from '../TimeRange';
import { TimeOfDay } from '../TimeOfDay';
import { TimesOfDay } from './TimesOfDay';

export type ScheduleTimeRange = TimeRange & {
  timeOfDay: TimeOfDay;
};

export type ScheduleTimeRangeJson = {
  timeOfDay: TimeOfDay;
  from: string;
  to: string;
};

export type TimesOfDayJson = Record<TimeOfDay, ScheduleTimeRangeJson>;

export const DefaultTimeRangeAny: ScheduleTimeRangeJson = {
  timeOfDay: 'any',
  from: '18:00:00',
  to: '18:00:00',
};

export const DefaultTimeRangeAfterWakeup: ScheduleTimeRangeJson = {
  timeOfDay: 'afterWakeUp',
  from: '07:00:00',
  to: '07:00:00',
};

export const DefaultTimeRangeMorning: ScheduleTimeRangeJson = {
  timeOfDay: 'morning',
  from: '09:00:00',
  to: '09:00:00',
};

export const DefaultTimeRangeNoon: ScheduleTimeRangeJson = {
  timeOfDay: 'noon',
  from: '12:00:00',
  to: '12:00:00',
};

export const DefaultTimeRangeAfternoon: ScheduleTimeRangeJson = {
  timeOfDay: 'afternoon',
  from: '14:00:00',
  to: '14:00:00',
};

export const DefaultTimeRangeEvening: ScheduleTimeRangeJson = {
  timeOfDay: 'evening',
  from: '20:00:00',
  to: '20:00:00',
};

export const DefaultTimeRangeNight: ScheduleTimeRangeJson = {
  timeOfDay: 'night',
  from: '22:00:00',
  to: '22:00:00',
};

export const DefaultTimeRangeBeforeBedTime: ScheduleTimeRangeJson = {
  timeOfDay: 'beforeBedTime',
  from: '23:00:00',
  to: '23:00:00',
};

export const DefaultTimeRanges: TimesOfDayJson = {
  any: {
    timeOfDay: 'any',
    from: '18:00:00',
    to: '18:00:00',
  },
  afterWakeUp: {
    timeOfDay: 'afterWakeUp',
    from: '07:00:00',
    to: '07:00:00',
  },
  morning: {
    timeOfDay: 'morning',
    from: '09:00:00',
    to: '09:00:00',
  },
  noon: {
    timeOfDay: 'noon',
    from: '12:00:00',
    to: '12:00:00',
  },
  afternoon: {
    timeOfDay: 'afternoon',
    from: '14:00:00',
    to: '14:00:00',
  },
  evening: {
    timeOfDay: 'evening',
    from: '20:00:00',
    to: '20:00:00',
  },
  night: {
    timeOfDay: 'night',
    from: '22:00:00',
    to: '22:00:00',
  },
  beforeBedTime: {
    timeOfDay: 'beforeBedTime',
    from: '23:00:00',
    to: '23:00:00',
  },
};

export function createScheduleTimeRange(json?: Partial<ScheduleTimeRange>): ScheduleTimeRange {
  const base = createTimeRangeFields(json);
  return makeAutoObservable({
    ...base,
    timeOfDay: json?.timeOfDay ?? 'any',
  });
}
